import { useNavigate } from "react-router-dom";
import { IconPlus, IconChevronRight } from "@tabler/icons-react";
import { Heading, Text } from "../../../../components/common/typography";
import { Button } from "../../../../components/common/button";
import { Chip } from "../../../../components/common/chip";
import { ShimmerLoader, Shimmer } from "../../../../components/common/shimmer/shimmer";
import { useLoyaltyPromotions } from "../../hooks/useLoyaltyPromotions";
import { promotionStatus, formatPromoDate, promotionScopeLabel } from "../../utils/promotion-status";
import { AppRoutes } from "../../../../common/routes/app_routes";

export function LoyaltyPromotionsSection() {
  const navigate = useNavigate();
  const { data: promotions, isLoading } = useLoyaltyPromotions();

  return (
    <div className="rounded-xl border border-borderDefault bg-bgWhite px-6 py-5 flex flex-col gap-4 max-sm:px-4">
      <div className="flex items-center justify-between gap-3 border-b border-borderDefault pb-4 max-sm:flex-col max-sm:items-start">
        <div className="flex flex-col">
          <Heading variant="h3" tone="dark">Points promotions</Heading>
          <Text variant="bodySm" tone="muted">
            Run multiple campaigns at once. Buyers earn the highest active multiplier.
          </Text>
        </div>
        <Button
          variant="primary"
          size="sm"
          leftIcon={<IconPlus size={16} />}
          onClick={() => navigate(AppRoutes.ADMIN_LOYALTY_PROMOTION_NEW)}
        >
          Add promotion
        </Button>
      </div>

      {isLoading ? (
        <ShimmerLoader message="Loading promotions…">
          <Shimmer className="h-24 rounded-xl" />
        </ShimmerLoader>
      ) : !promotions || promotions.length === 0 ? (
        <Text variant="bodySm" tone="muted">No promotions yet. Add one to boost points.</Text>
      ) : (
        <div className="flex flex-col divide-y divide-borderDefault">
          {promotions.map((p) => {
            const status = promotionStatus(p);
            return (
              <button
                key={p.id}
                type="button"
                onClick={() => navigate(AppRoutes.ADMIN_LOYALTY_PROMOTION_DETAIL.replace(":id", p.id))}
                className="flex items-center justify-between gap-4 py-3 text-left transition-colors hover:bg-bgLight -mx-2 px-2 rounded-lg"
              >
                <div className="flex min-w-0 flex-col gap-1">
                  <div className="flex items-center gap-2">
                    <Text variant="bodyBold" tone="dark" className="truncate">{p.name}</Text>
                    <Chip variant={status.variant}>{status.label}</Chip>
                  </div>
                  <Text variant="bodyXs" tone="muted">
                    {p.multiplier}× · {promotionScopeLabel(p)} · {formatPromoDate(p.startsAt)} → {formatPromoDate(p.endsAt)}
                  </Text>
                </div>
                <IconChevronRight size={18} className="shrink-0 text-textBody" />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
